import axios from 'axios'
//import Memcached from 'memcached'
import NodeCache from 'node-cache'


const resourcesTTL = 60 * 60 //one hour in seconds
const resourcesRefreshDuration = 1000 * 10 * 60 //ten minutes in milliseconds
const cache = new NodeCache({
  stdTTL: resourcesTTL,
  checkperiod: 60
});
var clientSideDataStore = {}
var fetchTimers = []
const CONFIGS = {
  kotv: {

    Header: require('./Header/package.json'),
    Footer: require('./Footer/package.json'),
    UControl: require('./UControl/package.json'),
    WarnEspRadar: require('./WarnEspRadar/package.json'),
    HomePageTakeover: require('./HomePageTakeover/package.json'),
    WeatherTakeover: require('./WeatherTakeover/package.json'),
    TopStories: require('./TopStories/package.json'),
    WeatherPage: require('./WeatherPage/package.json'),
    EarthquakeMap: require('./EarthquakeMap/package.json'),
    ArchiveCalendar: require('./ArchiveCalendar/package.json'),
    StoryPage: require('./StoryPage/package.json'),
    ElectionPage: require('./ElectionPage/package.json'),
    TrafficPage: require('./TrafficPage/package.json'),
    WeatherBlock: require('./WeatherBlock/package.json'),
    LayoutTwoByThree: require('./LayoutTwoByThree/package.json'),
      LayoutTwoThree: require('./LayoutTwoThree/package.json'),
    SkycamPage: require('./SkycamPage/package.json'),
    HourlyTemperatures: require('./HourlyTemperatures/package.json'),
    LayoutFullBleed: require('./LayoutFullBleed/package.json'),
    LayoutTwoByFour: require('./LayoutTwoByFour/package.json'),
    LayoutOneByFive: require('./LayoutOneByFive/package.json'),
    LayoutRightRailStories: require('./LayoutRightRailStories/package.json'),
    LayoutLandscapeList: require('./LayoutLandscapeList/package.json'),
    LayoutOneTwoThree: require('./LayoutOneTwoThree/package.json'),
    LayoutThreeByN: require('./LayoutThreeByN/package.json'),
    LayoutOneTwoList: require('./LayoutOneTwoList/package.json'),
    LayoutOneFeature: require('./LayoutOneFeature/package.json'),
    LayoutCarousel: require('./LayoutCarousel/package.json'),
    LayoutCarouselWithFeature: require('./LayoutCarouselWithFeature/package.json'),
    WindChart: require('./WindChart/package.json'),
    WatchesAndWarnings: require('./WatchesAndWarnings/package.json'),
    WeatherSummary: require('./WeatherSummary/package.json'),
    NineDayForecast: require('./NineDayForecast/package.json'),
    SkyCam: require('./SkyCam/package.json'),
    RadarCallToAction: require('./RadarCallToAction/package.json'),
    Almanac: require('./Almanac/package.json'),
    Image: require('./Image/package.json'),
    PlayFirstClipFromCategory: require('./PlayFirstClipFromCategory/package.json'),
    ResponsiveAdContainer: require('./ResponsiveAdContainer/package.json'),
    SchoolClosings: require('./SchoolClosings/package.json'),
    SendTo: require('./SendTo/package.json'),
    PageTitle: require('./PageTitle/package.json'),
    WeatherAlerts: require('./WeatherAlerts/package.json'),
    PlayAudio: require('./PlayAudio/package.json'),
    LakeLevels: require('./LakeLevels/package.json'),
    BaronResponsiveMap: require('./BaronResponsiveMap/package.json'),
    BaronWeatherSummary: require('./BaronWeatherSummary/package.json'),
    BaronNineDayForecast: require('./BaronNineDayForecast/package.json'),
    BaronWeatherBlock: require('./BaronWeatherBlock/package.json'),
    BaronHourlyTemperatures: require('./BaronHourlyTemperatures/package.json'),
    BaronWindChart: require('./BaronWindChart/package.json'),
    BaronAlmanac: require('./BaronAlmanac/package.json')
  },
  kwtv: {
    Header: require('./Header/package-kwtv.json'),
    Footer: require('./Footer/package-kwtv.json'),
    UControl: require('./UControl/package-kwtv.json'),
    WarnEspRadar: require('./WarnEspRadar/package-kwtv.json'),
    HomePageTakeover: require('./HomePageTakeover/package-kwtv.json'),
    WeatherTakeover: require('./WeatherTakeover/package-kwtv.json'),
    TopStories: require('./TopStories/package-kwtv.json'),
    WeatherPage: require('./WeatherPage/package-kwtv.json'),
    HourlyTemperatures: require('./HourlyTemperatures/package-kwtv.json'),
    EarthquakeMap: require('./EarthquakeMap/package-kwtv.json'),
    ArchiveCalendar: require('./ArchiveCalendar/package-kwtv.json'),
    StoryPage: require('./StoryPage/package-kwtv.json'),
    ElectionPage: require('./ElectionPage/package-kwtv.json'),
    TrafficPage: require('./TrafficPage/package-kwtv.json'),
    WeatherBlock: require('./WeatherBlock/package-kwtv.json'),
    LayoutTwoByThree: require('./LayoutTwoByThree/package-kwtv.json'),
      LayoutTwoThree: require('./LayoutTwoThree/package-kwtv.json'),
    SkycamPage: require('./SkycamPage/package-kwtv.json'),
    LayoutFullBleed: require('./LayoutFullBleed/package-kwtv.json'),
    LayoutTwoByFour: require('./LayoutTwoByFour/package-kwtv.json'),
    LayoutOneByFive: require('./LayoutOneByFive/package-kwtv.json'),
    LayoutOneTwoThree: require('./LayoutOneTwoThree/package-kwtv.json'),
    LayoutLandscapeList: require('./LayoutLandscapeList/package-kwtv.json'),
    LayoutOneTwoList: require('./LayoutOneTwoList/package-kwtv.json'),
    WindChart: require('./WindChart/package-kwtv.json'),
    LayoutCarousel: require('./LayoutCarousel/package-kwtv.json'),
    LayoutCarouselWithFeature: require('./LayoutCarouselWithFeature/package-kwtv.json'),
    LayoutThreeByN: require('./LayoutThreeByN/package-kwtv.json'),
    LayoutRightRailStories: require('./LayoutRightRailStories/package-kwtv.json'),
    LayoutOneFeature: require('./LayoutOneFeature/package-kwtv.json'),
    WatchesAndWarnings: require('./WatchesAndWarnings/package-kwtv.json'),
    WeatherSummary: require('./WeatherSummary/package-kwtv.json'),
    NineDayForecast: require('./NineDayForecast/package-kwtv.json'),
    SkyCam: require('./SkyCam/package-kwtv.json'),
    RadarCallToAction: require('./RadarCallToAction/package-kwtv.json'),
    Almanac: require('./Almanac/package-kwtv.json'),
    PlayFirstClipFromCategory: require('./PlayFirstClipFromCategory/package-kwtv.json'),
    Image: require('./Image/package-kwtv.json'),
    ResponsiveAdContainer: require('./ResponsiveAdContainer/package-kwtv.json'),
    SchoolClosings: require('./SchoolClosings/package-kwtv.json'),
    SendTo: require('./SendTo/package-kwtv.json'),
    PageTitle: require('./PageTitle/package-kwtv.json'),
    WeatherAlerts: require('./WeatherAlerts/package-kwtv.json'),
    LakeLevels: require('./LakeLevels/package-kwtv.json'),
    BaronResponsiveMap: require('./BaronResponsiveMap/package-kwtv.json'),
    BaronWeatherSummary: require('./BaronWeatherSummary/package-kwtv.json'),
    BaronNineDayForecast: require('./BaronNineDayForecast/package-kwtv.json'),
    BaronWeatherBlock: require('./BaronWeatherBlock/package-kwtv.json'),
    BaronHourlyTemperatures: require('./BaronHourlyTemperatures/package-kwtv.json'),
    BaronWindChart: require('./BaronWindChart/package-kwtv.json'),
    BaronAlmanac: require('./BaronAlmanac/package-kwtv.json')
  },
  kvoo: {
    WeatherBlock: require('./WeatherBlock/package-kvoo.json'),
    RadioBanner: require('./RadioBanner/package.json'),
    PlayAudio: require('./PlayAudio/package.json'),
    BaronWeatherBlock: require('./BaronWeatherBlock/package-kvoo.json')
  }
}


const acceptedAffiliates = ['kotv', 'kwtv', 'khtt', 'kbez', 'kvoo', 'kfaq', 'kxbl']
var affiliate
var affiliateAlreadySet = false;



function init(a) {

  var realAffiliate = acceptedAffiliates.some(aa => {
    return aa === a
  })

  if (realAffiliate && !affiliateAlreadySet) {
    affiliate = a
    console.log('init dataStore affiliate %s', affiliate)
    affiliateAlreadySet = true;
    if (typeof window == 'object') { //this is how we initialize the client-side DataStore
      affiliate = window.affiliate;
      var affiliateAlreadySet = true;
    } else { //on server
      fetchAllResources()
      setInterval(fetchAllResources, resourcesRefreshDuration)
    }
    return true
  }
  return false
}

function getAffiliate() {
  return affiliate
}

function props(moduleName, params = null) {

  if (typeof window === 'object') {
    let res = getClientSideProps(moduleName, params)
    res.FRN_page = {
      uri: 'https://www.newson6.com?hideFooter=true'
    }
    return res
  } else {
    let res = getServerSideProps(moduleName, params)
    res.FRN_page = {
      uri: 'https://www.newson6.com?hideFooter=true'
    }
    return res
  }
}


function getServerSideProps(moduleName, params) {

  if (!moduleName)
    return {}

  var all = CONFIGS[affiliate]

  try {
    let config = all[moduleName]
    delete config.defaultProps.FRN_rawResponses
    if (config.FRN_resourceEndpoints && config.FRN_resourceEndpoints.length) {
      config.defaultProps.FRN_rawResponses = config.FRN_resourceEndpoints.map((endpoint) => {
        return get(endpoint, params)
      })
      clientSideDataStore[moduleName] = config.defaultProps

    } else { //just in case there are no FRN_resourceEndpoints
      clientSideDataStore[moduleName] = config.defaultProps
    }
    config.defaultProps.params = params
    return config.defaultProps
  } catch (e) {
    console.error("Something went wrong in the Data Store getting server side props", e)
    return {}
  }
}

function getClientSideProps(moduleName) {
  if (!window.clientSideDataStore) {
    console.log('clientSideDataStore not present')
    return {}
  }

  if (!window.clientSideDataStore.hasOwnProperty(moduleName)) {
    console.log('clientSideDataStore does not have a ' + moduleName + ' property..')
    return {}
  }

  return window.clientSideDataStore[moduleName]
}


function clearClientSideDataStore() {
  clientSideDataStore = {}
}

function getClientSideDataStore() {
  return clientSideDataStore
}

function makeUrl(params, str) {
  // console.log('make url from ' + str)
  // console.log('from',params)
  let url = str
  for (var p in params) {
    if (params.hasOwnProperty(p)) {

      url = url.replace('${' + p + '}', params[p])
    }
  }
  // console.log('final url ',url)
  return url
}


function get(endpoint, params) {

  if (!endpoint.url || !endpoint.type) //some are empty
    return {}
  let data = false
  if (typeof params === 'object' && params !== null) { //variable endpoints
    let url = makeUrl(params, endpoint.url)
    endpoint = Object.assign({}, {
      url: url,
      type: endpoint.type
    })
  }
  data = cache.get(endpoint.url)

  if (data)
    return {
      data: data
    }

  else if (endpoint.type === 'json')
    findJsonResource(endpoint)
  else if (endpoint.type === 'xml')
    findXmlResource(endpoint)
  else if (endpoint.type === 'jsonp')
    findJSONPResource(endpoint)
  return {}
}


function fetchAllResources() {
  var all = CONFIGS[affiliate]
  let count = 0
  for (var configKey in all) {
    if (all.hasOwnProperty(configKey)) {
      let config = all[configKey]
      if (config.FRN_resourceEndpoints && config.FRN_resourceEndpoints.length) {
        count += config.FRN_resourceEndpoints.map(get)
          .length
      }
    }
  }
  console.log('Data Store Initialized and fetched ' + count + ' resources')
}

function httpErrorHandler(error) {
  console.log('httpErrorHandler')
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error(error.response.status + ' from ' + error.config.url)
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.log('Error', error.message);
  }
  //  console.log(error.config);
}


function findJsonResource(endpoint) { //this ONLY works for JSON endpoints
  axios.get(endpoint.url)
    .then((res) => {
      cache.set(endpoint.url, res.data)
    })
    .catch(httpErrorHandler)
}

function findXmlResource(endpoint) { //this ONLY works for JSON endpoints
  axios.get(endpoint.url)
    .then((res) => {
      cache.set(endpoint.url, res.data)
    })
    .catch(httpErrorHandler)
}

function findJSONPResource(endpoint) {
  console.log('jsonp not supported in DataStore yet')
}





if (typeof window == 'object')
  window.DataStore = {
    init,
    props,
    getAffiliate
  }

export default {
  init,
  props,
  clearClientSideDataStore,
  getAffiliate,
  getClientSideDataStore
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/DataStore.js